import { z } from 'zod'

export const ACCOUNT_TABS = ['users', 'orgs'] as const

export type AccountTab = (typeof ACCOUNT_TABS)[number]

export const accountManagementSearchSchema = z.object({
  q: z.string().optional(),
  page: z.number().optional(),
  tab: z.enum(ACCOUNT_TABS).optional().catch(undefined),
})

export function resolveAccountTab(tab: AccountTab | undefined): AccountTab {
  return tab ?? 'users'
}

export function tabSearchParam(tab: AccountTab): 'orgs' | undefined {
  if (tab === 'orgs') {
    return 'orgs'
  }
  return undefined
}

export function isAccountTab(value: string): value is AccountTab {
  return (ACCOUNT_TABS as readonly string[]).includes(value)
}
